// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._34cQb{width:100%;height:auto}.Z6vrx{white-space:pre-line}._34cQb,.dRQRP{margin-top:1.5rem;font-size:18px;font-weight:500;line-height:25px;font-family:var(--heading-font);letter-spacing:.5px}._2BLIJ,.Z6vrx{margin-top:.75rem}._2BLIJ li{display:-ms-flexbox;display:flex;grid-gap:12px;gap:12px;grid-gap:.75rem;gap:.75rem;font-size:16px;font-weight:400;line-height:26px;font-family:var(--base-font)}._2BLIJ li:not(:last-child){margin-bottom:1rem}._1FCJM{width:4px;width:.25rem;height:26px;height:1.625rem;border-radius:.125rem;background-color:#0373f9;margin-left:1rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"img": "_34cQb",
	"text": "Z6vrx",
	"subTitle": "dRQRP",
	"bulletPoint": "_2BLIJ",
	"listStyle": "_1FCJM"
};
module.exports = exports;
